import { render, staticRenderFns } from "./CustomerDetailsHeader.vue?vue&type=template&id=4efe19c7"
import script from "./CustomerDetailsHeader.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports